'use strict'

// const IP = "192.168.199.199:5000/socket";
// const IP =  "iotest.concoai.com"
// const IP = "192.168.26.166:40443/socket";//非私有化打包用
const IP = "189.18.10.150:40443/socket";//私有化打包用
const HOST = "https://" + IP + "/";
const WS = "wss://" + IP + "/ws/";

// 导出信令服务器地址，便于页面调试打印
export const SIGNAL_IP = IP;
export const SIGNAL_WS = WS;

const cfg = {
	"iceServers": [{
		// "urls": "turn:192.168.26.166:3478",//非私有化打包用
		"urls": "turn:189.18.10.150:5349",//私有化打包用
		// "urls": "turn:turn.concoai.com",
		"username": "keanke",
		"credential": "keanke@123"
	}]
}

const config = {
	peer: Object,
	room: null,
	userId: null,
	fromId: null,
	ws: null,
	localStream: null,
	roomSize: 2,
	userList: [],
	passive: false
}

/**
 * 多人通话
 * @returns {Promise<any>}
 */
function multiPersonCall() {

}

/**
 * 获取房间里面的用户
 * @returns {Promise<any>}
 */
function getUserList() {
	return new Promise((resolve, reject) => {
		const http = new XMLHttpRequest();
		http.open("get", HOST + "userListByRoom?room=" + config.room);
		http.onreadystatechange = function() {
			if (http.responseText) {
				let list = JSON.parse(http.responseText);
				let userList = list.map((item) => {
						if (item) {
							return item.userId
						};
					})
					.filter((item) => {
						if (item && item != config.userId) {
							return item
						}
					});
				return resolve(userList);
			}
		}
		http.send();
	})
}

/**
 * webrtc
 * @param options
 * @constructor
 */
export function WebRtc(options) {
	if (!options || !options.userId) {
		console.error("create WebRtc error userId is null");
		return;
	}

	// if (config.room) {
	// 	return;
	// }

	config.userId = options.userId;
	config.passive = options.passive;

	this.createRoom = (opts) => {
		let timer;
		timer = setInterval(() => {
			if (config.ws && (config.ws.readyState == 1 || config.ws.readyState == 3) ) {
				clearInterval(timer);
				createRooms({
					...opts,
					userId: options.userId
				});
			}
		}, 100);
	}

	// 呼叫
	this.call = () => {
		return call({
			userId: config.userId
		})
	};

	socketConnection(options.listen);

	// 应答回复
	this.reply = () => {
		sendRing();
		createPeerConnection();
	}

	this.leave = leave;
}

/**
 * 呼叫
 * @param options
 */
function call(options) {
	getLocalMediaStream()
	if (isUserId(options)) {
		// 创建peer
		if (!config.room) {
			if (isRoom(options)) {
				config.room = options.room;
				createRooms({
					userId: options,
					room: options.room
				});
			}
		} else {
			joinRoom({
				room: config.room,
				userId: options.userId
			});
		}
		// sendInvite({
		// 	room: config.room,
		// 	userId: config.userId
		// });
	}
	return true;
}

/**
 * 多人通话
 * @param options
 */
function callPassive(options) {
	sendInvite({
		room: config.room,
		userId: config.userId
	});
	return true;
}

/**
 * 创建房间
 * @param options
 */
function createRooms(options) {
	if (isSocket() && isRoom(options) && isUserId(options)) {
		config.room = options.room;
		let data = {
			room: options.room,
			userID: options.userId,
			roomSize: options.roomSize ? options.roomSize : config.roomSize,
		}
		config.ws.send(JSON.stringify({
			eventName: "__create",
			data: data
		}));

		config.ws.send(JSON.stringify({
			eventName: "__join",
			data: data
		}));
	}
}

/**
 * 发送响铃回复
 */
function sendRing() {
	if (isSocket() && isRoom(config)) {
		let data = {
			toID: config.fromId,
			userID: config.userId,
			room: config.room
		}
		config.ws.send(JSON.stringify({
			eventName: "__ring",
			data: data
		}));
	}
}

/**
 * 发送邀请
 * @param options
 */
function sendInvite(options) {
	if (isSocket() && isRoom(options) && isUserId(options)) {
		getUserList().then(res => {
			config.userList = res;
			let newList = []
			if (res.length == 0) {
				console.error("There are no people in the room!");
				return;
			}
			if (res && res.length > 0) {
				newList = Array.from(new Set(res));
			}
			let data = {
				userList: newList.join(","),
				room: options.room,
				inviteID: options.userId,
				audioOnly: true,
			}
			config.ws.send(JSON.stringify({
				eventName: "__invite",
				data: data
			}));
		}).catch(e => {
			console.error("get userList error", e);
		})
	}
}

/**
 * 发送answer
 * @param options
 */
function sendAnswer(options) {
	if (isSocket()) {
		config.ws.send(JSON.stringify({
			"eventName": "__answer",
			data: options
		}));
	}
}

/**
 * 加入房间
 * @param room
 * @param userId
 */
function joinRoom() {
	if (isSocket()) {
		let data = {
			userID: config.userId,
			room: config.room
		}
		config.ws.send(JSON.stringify({
			"eventName": "__join",
			data: data
		}));
	}
}

/**
 * 链接socket
 */
function socketConnection(callback) {
	getLocalMediaStream();
	if (!config.ws) {
		console.log("✅信令服务器连接地址:", WS + config.userId + "/1");
		config.ws = new WebSocket(WS + config.userId + "/1");
		config.ws.onopen = () => {
			console.log("open create socket success!");
		}

		config.ws.onmessage = (res) => {
			let data = JSON.parse(res.data);
			console.log("response message", data);
			if (!data.eventName) {
				console.log("socket returns no event type name");
				return;
			}
			socketRes(data);
			setInterval(() => {
				config.ws.send(JSON.stringify({
					eventName: "heart",
					data: {
						userID: config.userId
					}
				}));
			}, 5000000);
			if (typeof callback == "function") {
				callback(data);
			}
		}

		config.ws.onclose = () => {
			console.log("socket connection close!");
		}

		config.ws.onerror = (err) => {
			console.error("socket connection error", err);
		}
	}
}

/**
 * socket返回处理
 */
function socketRes(desc) {
	switch (desc.eventName) {
		case "__login_success":
			break;
		case "__offer":
			createAnswer(desc.data.sdp);
			break;
		case "__answer":
			setRemoteDesc(desc.data.sdp);
			break;
		case "__ice_candidate":
			setIcecandidate(desc);
			break;
		case "__invite":
			config.fromId = desc.data.inviteID;
			sendRing()
			createPeerConnection()
			break;
		case "__peers":
			if (config.passive) {
				callPassive({ userId: config.userId })
			}
			break;
		case "__new_peer":
			break;
		case "__leave":
			break;
		case "__ring":
			config.fromId = desc.data.userID;
			createPeerConnection();
			createOffer();
			break;
		default:
			break;
	}
}
/**
 * 离开
 */
function leave(callback) {
	console.log('退出房间..')
	let data = {
		room: config.room,
		fromID: config.userId
	}
	config.ws.send(JSON.stringify({eventName: "__leave", data: data}))
	closeLocalStream();
	closePeerConnection();
	// config.ws.close();
	// config.ws = null;
	// socketConnection(callback);
	// setTimeout(()=>{
	//     joinRoom();
	// }, 2000)
}

/**
 * 创建answer
 * @param sdp
 */
function createAnswer(sdp) {
	if (isPeer()) {
		config.peer[config.userId + "_" + config.fromId].setRemoteDescription(new RTCSessionDescription({
			type: "offer",
			sdp: sdp
		}));
		config.peer[config.userId + "_" + config.fromId].createAnswer().then(getAnswer).catch(handleAnswerError);
	}
}

/**
 * 设置远端描述
 * @param sdp
 */
function setRemoteDesc(sdp) {
	if (isPeer()) {
		config.peer[config.userId + "_" + config.fromId].setRemoteDescription(new RTCSessionDescription({
			type: "answer",
			sdp: sdp
		}));
	}
}

/**
 * 设置ice
 * @param desc
 */
function setIcecandidate(desc) {
	if (isPeer()) {
		let data = {
			sdpMLineIndex: desc.data.label,
			candidate: desc.data.candidate
		}
		config.peer[config.userId + "_" + config.fromId].addIceCandidate(data);
	}
}


/**
 * 发送answer
 */
function getAnswer(desc) {
	if (isPeer()) {
		config.peer[config.userId + "_" + config.fromId].setLocalDescription(desc);
		sendAnswer({
			sdp: desc.sdp,
			fromID: config.userId,
			userID: config.fromId
		})
	}
}

/**
 * 创建offer
 * @param desc
 */
function createOffer() {
	if (isPeer()) {
		let options = {
			offerToReceiveAudio: 1,
			offerToReceiveVideo: 1,
		}
		config.peer[config.userId + "_" + config.fromId].createOffer(options).then(getOffer).catch(handleOfferError);
	}
}

/**
 * 发送offer
 */
function getOffer(desc) {
	if (isPeer()) {
		console.log("create offer", config);
		config.peer[config.userId + "_" + config.fromId].setLocalDescription(desc);
		sendOffer({
			sdp: desc.sdp,
			userID: config.fromId,
			fromID: config.userId
		});
	}
}

/**
 * 发送offer
 * @param options
 */
function sendOffer(options) {
	if (isSocket()) {
		config.ws.send(JSON.stringify({
			eventName: "__offer",
			data: options
		}))
	}
}

/**
 * 捕获answer错误
 */
function handleAnswerError(e) {
	console.error("Failed to get answer!", e);
}

/**
 * 捕获offer
 */
function handleOfferError(e) {
	console.error("Failed to get offer!", e);
}

/**
 * 创建peers
 */
function createPeerConnection() {
	console.log("create RTCPeerConnection");
	if (!config.userId) {
		console.log("create RTCPeerConnection error userId null!");
		return;
	}
	if (!config.peer[config.userId + "_" + config.fromId]) {

		config.peer[config.userId + "_" + config.fromId] = new RTCPeerConnection(cfg);

		config.peer[config.userId + "_" + config.fromId].onicecandidate = sendIcecandidate;

		config.peer[config.userId + "_" + config.fromId].ontrack = ontrack;

		if (!config.localStream) {
			console.error("get localStream error!");
			return;
		}

		config.localStream.getTracks().forEach((track) => {
			config.peer[config.userId + "_" + config.fromId].addTrack(track, config.localStream);
		});
		console.log("创建完成")
	}
}

/**
 * 创建音频标签
 * @param e
 */
function ontrack(e) {
	let audit = document.createElement("audio");
	audit.srcObject = e.streams[0];
	audit.controls = true;
	audit.autoplay = true;
	audit.style.display = "none";
	document.body.appendChild(audit);
}

/**
 * 发送iceSocket
 */
function sendIcecandidate(e) {
	if (e.candidate) {
		let data = {
			userID: config.fromId,
			fromID: config.userId,
			label: e.candidate.sdpMLineIndex,
			id: e.candidate.sdpMid,
			candidate: e.candidate.candidate
		}
		config.ws.send(JSON.stringify({
			"eventName": "__ice_candidate",
			data: data
		}));
	}
}

/**
 * 获取本地媒体流
 */
function getLocalMediaStream() {
	if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
		console.error("browser does not support!");
		return;
	}
	let constrains = {
		audio: {
			// 降噪
			echoCancellation: true,
			// 回音消除
			noiseSuppression: true,
		},
		video: false
	}
	window.navigator.getUserMedia(constrains, setLocalStream, handleLocalStreamError);
	return true;
}

/**
 * 设置本地流
 * @param stream
 */
function setLocalStream(stream) {
	config.localStream = stream;
}

/**
 * 捕获流错误
 * @param e
 */
function handleLocalStreamError(e) {
	console.error("Failed to get localStream!", e);
}

/**
 * 关闭本地音频流
 */
function closeLocalStream() {
	if (config.localStream && config.localStream.getTracks()) {
		config.localStream.getTracks().forEach(track => {
			track.stop();
		})
	}
}

/**
 * 关闭peerConnection
 */
function closePeerConnection() {
	if (config.peer[config.userId + "_" + config.fromId]) {
		config.peer[config.userId + "_" + config.fromId].close();
		config.peer[config.userId + "_" + config.fromId] = null;
	}
}

/**
 * 验证房间
 * @param options
 * @returns {boolean}
 */
function isRoom(options) {
	if (!options.room) {
		console.error("room is null!");
		return false;
	}
	return true;
}

/**
 * 验证userId
 * @param options
 * @returns {boolean}
 */
function isUserId(options) {
	if (!options || !options.userId) {
		console.error("userId is null!");
		return false;
	}
	return true;
}

/**
 * 判断socket是否链接
 */
function isSocket() {
	if (!config.ws) {
		console.error("socket create error");
		return false;
	}
	return true;
}

/**
 * 验证peerConnection
 * @returns {boolean}
 */
function isPeer() {
	console.log(config.peer[config.userId + "_" + config.fromId])
	if (!config.peer[config.userId + "_" + config.fromId]) {
		console.error("peerConnection is null");
		return false;
	}
	return true;
}



// WEBPACK FOOTER //
// ./src/utils/WebRtc.js